module.exports = __webpack_public_path__ + "7bd995dc357bb5861583b8907b6ba85e.pdf";